import {
  Application, LanguageManager, TranslationManager, Managers
} from '@levelapp/softfabric';
import Translation from '../DTO/Translation';

const translate = (title : string) => {
  const languageManager = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);
  const translationManager = Application.current.resolve<TranslationManager>(Managers.TRANSLATION_MANAGER);

  return translationManager.translate(title, languageManager.language);
};

 const getCorrectTranslation = (text: Translation) => {
        if(!text)
            return '';
        let language = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER).language;
        switch (language) {
            case "fr-BE":
                return text.fr;
            case "nl-BE":
                return text.nl;
            case "en-GB":
                return text.en;
            default:
                return text.fr;
        }
    }

export
{
  translate, getCorrectTranslation
};
